import $ from "expose-loader?jQuery!expose-loader?$!jquery";
